import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/siteData';

export default function LatestUpdates() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              最新更新
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              每日更新，为您呈现一区二区最新内容动态
            </p>
          </div>
          <Link
            to="/category/latest"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-0.5 bg-secondary-500 text-white text-xs font-label font-medium rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2 mb-3">
                  {item.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views.toLocaleString()} 浏览
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest"
            className="inline-flex items-center gap-1 px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}